import { ComponentPropsWithoutRef } from "react";
import { useTranslation } from "react-i18next";

export function AddProjectOverrideButton({
  onAddOverride,
  ...props
}: ComponentPropsWithoutRef<"button"> & {
  onAddOverride: () => void;
}) {
  const { t } = useTranslation();

  return (
    <button
      {...props}
      className="project-override-button"
      data-testid="project_override-footer-add"
      onClick={onAddOverride}
    >
      <div className="footer">
        <span className="footer-message" data-testid="footer-message">
          {t("nlmsettings.project_override_addrow_text")}
        </span>
      </div>
    </button>
  );
}
